import { SAVE_CLIENT_DATA } from "../actions/actions.types";

const INITIAL_STATE = {}

const clientDataReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case SAVE_CLIENT_DATA:
            return {
                ...state,
                ...action.payload
            }
        
        default:
            return state
    }
}

export default clientDataReducer;